import { render, staticRenderFns } from "./CreateActivated.vue?vue&type=template&id=1abf3942&scoped=true"
import script from "./CreateActivated.vue?vue&type=script&lang=js"
export * from "./CreateActivated.vue?vue&type=script&lang=js"
import style0 from "./CreateActivated.vue?vue&type=style&index=0&id=1abf3942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abf3942",
  null
  
)

export default component.exports